// src/pages/Devoluciones.jsx
import React, { useEffect, useState } from 'react';
import { collection, getDocs, addDoc, deleteDoc, Timestamp, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import * as XLSX from 'xlsx';

const Devoluciones = () => {
  const [ventas, setVentas] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [devoluciones, setDevoluciones] = useState([]);
  const [rangoInicio, setRangoInicio] = useState('');
  const [rangoFin, setRangoFin] = useState('');
  const { rol } = useUser();

  useEffect(() => {
    const fetchVentas = async () => {
      const snap = await getDocs(collection(db, 'ventas'));
      setVentas(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    const fetchDevoluciones = async () => {
      const snap = await getDocs(collection(db, 'devoluciones'));
      setDevoluciones(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchVentas();
    fetchDevoluciones();
  }, []);

  const handleBusqueda = (texto) => {
    setBusqueda(texto);
    if (!texto) return setResultados([]);
    const filtrado = [];
    ventas.forEach(v => {
      v.productos?.forEach(p => {
        if (
          p.nombre?.toLowerCase().includes(texto.toLowerCase()) ||
          p.codigo?.toLowerCase().includes(texto.toLowerCase())
        ) {
          filtrado.push({ ...v, producto: p });
        }
      });
    });
    setResultados(filtrado);
  };

  const procesarDevolucion = async (item) => {
    const cantidad = prompt('¿Cantidad a devolver?', item.producto.cantidad);
    const cantNum = parseInt(cantidad);
    if (!cantNum || cantNum <= 0) return;

    const nueva = {
      ventaId: item.id,
      producto: item.producto,
      cantidad: cantNum,
      total: cantNum * item.producto.precio,
      fecha: Timestamp.now(),
      vendedor: item.vendedor || 'Desconocido',
      clienteId: item.clienteId || 'N/A'
    };

    await addDoc(collection(db, 'devoluciones'), nueva);

    const productoRef = doc(db, 'inventario', item.producto.id);
    await updateDoc(productoRef, {
      cantidad: item.producto.cantidad + cantNum
    });

    const ventaRef = doc(db, 'ventas', item.id);
    const nuevosProductos = item.productos.map(p => {
      if (p.codigo === item.producto.codigo) {
        return { ...p, devuelto: true };
      }
      return p;
    });
    await updateDoc(ventaRef, { productos: nuevosProductos });

    alert('Devolución registrada');
  };

  const eliminarDevolucion = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta devolución?')) {
      await deleteDoc(doc(db, 'devoluciones', id));
      const snap = await getDocs(collection(db, 'devoluciones'));
      setDevoluciones(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  };

  const devolucionesFiltradas = devoluciones.filter(d => {
    const fecha = d.fecha?.toDate ? d.fecha.toDate() : new Date(d.fecha);
    if (!fecha) return false;
    const desde = rangoInicio ? new Date(rangoInicio) : null;
    const hasta = rangoFin ? new Date(rangoFin) : null;
    return (
      (!desde || fecha >= desde) &&
      (!hasta || fecha <= hasta)
    );
  });

  const exportarExcel = () => {
    const data = devolucionesFiltradas.map(d => ({
      Fecha: (d.fecha?.toDate ? d.fecha.toDate() : new Date(d.fecha)).toLocaleString(),
      Producto: d.producto?.nombre,
      Cantidad: d.cantidad,
      Precio: `$${d.producto?.precio?.toFixed(2) || '0.00'}`,
      Total: `$${d.total?.toFixed(2) || '0.00'}`,
      Vendedor: d.vendedor,
      Cliente: d.clienteId
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Devoluciones');
    XLSX.writeFile(wb, 'devoluciones.xlsx');
  };

  return (
    <div className="devoluciones-container">
      <h2>Gestión de Devoluciones</h2>

      <input
        type="text"
        placeholder="Buscar producto o código..."
        value={busqueda}
        onChange={e => handleBusqueda(e.target.value)}
        className="input-busqueda"
      />

      <div className="resultados-busqueda">
        {resultados.map((r, i) => (
          <div key={i} className="resultado-card">
            <p><strong>Producto:</strong> {r.producto.nombre}</p>
            <p><strong>Precio:</strong> ${r.producto.precio?.toFixed(2) || '0.00'}</p>
            <p><strong>Fecha:</strong> {new Date(r.fecha?.seconds * 1000).toLocaleString()}</p>
            {r.producto.devuelto ? (
              <span style={{ color: 'orange', fontWeight: 'bold' }}>DEVUELTO</span>
            ) : (
              <button onClick={() => procesarDevolucion(r)}>Devolver</button>
            )}
          </div>
        ))}
      </div>

      <h3>Devoluciones Realizadas</h3>

      <div className="filtros-fechas">
        <label>Desde:</label>
        <input type="date" value={rangoInicio} onChange={e => setRangoInicio(e.target.value)} />
        <label>Hasta:</label>
        <input type="date" value={rangoFin} onChange={e => setRangoFin(e.target.value)} />
        <button onClick={exportarExcel}>Exportar a Excel</button>
      </div>

      <div className="lista-devoluciones">
        {devolucionesFiltradas.map((d, idx) => (
          <div key={idx} className="devolucion-card">
            <p><strong>Producto:</strong> {d.producto?.nombre}</p>
            <p><strong>Cantidad:</strong> {d.cantidad}</p>
            <p><strong>Total:</strong> ${d.total?.toFixed(2) || '0.00'}</p>
            <p><strong>Vendedor:</strong> {d.vendedor}</p>
            <p><strong>Fecha:</strong> {(d.fecha?.toDate ? d.fecha.toDate() : new Date(d.fecha)).toLocaleString()}</p>
            {rol === 'admin' && (
              <button onClick={() => eliminarDevolucion(d.id)} style={{ background: 'red', marginTop: '10px' }}>
                Eliminar
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Devoluciones;
